import { Link } from "react-router-dom";
import { Breadcrumb } from '@/components/ui/Breadcrumb';
import { productList } from '@/data/pricing';
import { PriceDisplay, SavingDisplay } from '@/components/ui/PriceDisplay';

export const PricingPage = () => {
  return (
    <main>
      <div className="max-w-6xl mx-auto px-6 lg:px-8 pt-8">
        <Breadcrumb items={[{ label: 'Pricing' }]} />
      </div>
      <section className="pt-32 pb-16 px-6 max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-serif text-ink mb-6">
          Transparent pricing for serious practitioners.
        </h1>
        <p className="text-xl text-ink/70/80 mb-16 max-w-3xl">
          We do not hide our costs behind consultation forms. If you are ready to grow your practice, our pricing is straightforward.
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {productList.map((product) => {
            const isFeatured = Boolean(product.featured);
            return (
              <div
                key={product.id}
                className={
                  isFeatured
                    ? "border-2 border-rule-3 bg-white p-8 relative transform md:-translate-y-4 shadow-lg flex flex-col justify-between"
                    : "border border-ground-deep bg-white p-8 flex flex-col justify-between"
                }
              >
                <div>
                  {product.savings && (
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-rule-3 text-white px-4 py-1 text-xs font-bold uppercase tracking-widest whitespace-nowrap min-h-[1.5rem] flex items-center">
                      <SavingDisplay />
                    </div>
                  )}
                  <h2 className="text-2xl font-serif text-ink mb-2">{product.name}</h2>
                  <div className="text-xl sm:text-2xl font-bold text-ink my-6 min-h-[2.5rem] flex items-center">
                    <PriceDisplay productKey={product.id} />
                  </div>
                  {product.note && (
                    <p className="text-sm text-rule-3 mb-4">{product.note}</p>
                  )}
                  {product.features && (
                    <ul className="space-y-3 mb-8 text-ink/70/80">
                      {product.features.map((feature, idx) => (
                        <li key={idx}>• {feature}</li>
                      ))}
                    </ul>
                  )}
                </div>
                <Link
                  to={product.cta?.href || "/register"}
                  className={
                    isFeatured
                      ? "block text-center bg-ink text-white px-6 py-3 uppercase tracking-widest text-sm font-bold hover:bg-ink/70 transition-colors"
                      : "block text-center border border-ink text-ink px-6 py-3 uppercase tracking-widest text-sm font-bold hover:bg-ground transition-colors"
                  }
                >
                  {product.cta?.label || "Register Now"}
                </Link>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default PricingPage;
